// extracted by mini-css-extract-plugin
export default {"cardClass":"CarouselItems_cardClass__FBbRB","content":"CarouselItems_content__Nw8gf","action":"CarouselItems_action__grDPc","btn":"CarouselItems_btn__qqCR3"};